module.exports = __webpack_public_path__ + "assets/sa-instagram.a48e10c0.svg";